<div class="column-preference-container">
  <g99-button
    variant="medium"
    color="transparent-with-border"
    [showIconOnMobile]="true"
    (buttonClick)="onPopoverOpen($event)"
  >
    <g99-icon-btn
      class="configure-button"
      [icon]="icon"
      [height]="18"
      [width]="18"
      [strokeColor]="'#000'"
    />
    Configure Columns
  </g99-button>
  <lib-g99-shared-popover #popoverRef [content]="popoverContent" />
  <!-- Content Template -->
  <ng-template #popoverContent>
    <!-- Search Box using lib-input -->
    <div class="search-wrapper">
      <lib-input
        placeholder="Search columns..."
        inputId="searchColumns"
        [(ngModel)]="searchText"
      />
    </div>

    <!-- Scrollable checkbox list -->
    <div class="checkbox-list">
      @for (col of filteredColumns; track $index) {
        <div class="checkbox-item">
          <lib-input-checkbox
            [id]="col.value"
            [label]="col.label"
            [disabled]="col?.locked ?? false"
            [(ngModel)]="selectedMap[col.value]"
          />
        </div>
      }
    </div>

    <!-- Footer Buttons -->
    <div class="footer-btn-container">
      <lib-footer-button
        [isFormValid]="true"
        [isFormDirty]="true"
        [saveBtnColor]="'green'"
        [showCancelBtn]="true"
        [showResetBtn]="true"
        [saveBtnLabel]="'Save'"
        [resetBtnLabel]="'Reset'"
        [isFormSubmitting]="isSubmitting"
        (saveForm)="save()"
        (resetForm)="reset()"
        (cancelForm)="popoverRef.hide()"
      />
    </div>
  </ng-template>
</div>
